import script from "./PerformerProjectFormRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormRow.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormRow.vue?vue&type=style&index=0&id=a6ecce84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6ecce84"]])

export default __exports__